import { useEffect, useState } from 'react';

import { LANGUAGES } from './language.constants';

export default function languageHelper() {
  const hasWindow = typeof window !== 'undefined';

  function getLangType(): { lang: string } {
    return {
      lang: window.location.pathname.includes(`/${LANGUAGES.en}/`)
        ? LANGUAGES.en
        : LANGUAGES.nl,
    };
  }

  const [getLanguage, setGetLanguage] = useState({ lang: LANGUAGES.nl });

  useEffect(() => {
    if (hasWindow) {
      setGetLanguage(getLangType());
    }
  }, []);
  return getLanguage;
}
